// eslint-disable-next-line
import React from "react";
import "../styles/Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Logo & Contact Section */}
        <div className="footer-logo-section">
          <img
            src="/logo.png"
            alt="Anthem Yash Kirti Infracity Logo"
            className="footer-logo"
          />
          <h3 className="footer-tagline">
            “The Gold Standard in Luxury Living”
          </h3>

          <p>
            📞{" "}
            <a href="tel:+918882711036" className="footer-link">
              +91-8882711036
            </a>
          </p>
          <p>
            ✉️ <a href="mailto:Info@kingdomhomes.in">Info@kingdomhomes.in</a>
          </p>
          <p>
            📍 C-64, 2nd Floor, RDC Rajnagar, <br />
            Ghaziabad, Uttar Pradesh - 201002
          </p>
        </div>

        {/* Info Columns */}
        <div className="footer-columns">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/gallery">Gallery</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Projects</h4>
            <ul>
              <li>
                <a href="/portfolio">School</a>
              </li>
              <li>
                <a href="/portfolio">Residential</a>
              </li>
              <li>
                <a href="/portfolio">Commercial</a>
              </li>
              <li>
                <a href="/portfolio">Entertainment</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/downloads">Downloads</a>
              </li>
              <li>
                <a href="/sales">Sales Inquiry</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/status">Construction Status</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Anthem Yash Kirti Infracity Pvt.
          Ltd. All rights reserved.
        </p>
        <p className="company-name">ANTHEM GROUP</p>

        <div className="footer-social">
          <span>Follow Us </span>
          <div className="icons">
            <a href="/" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="/" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="/" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
